module.exports = __webpack_public_path__ + "static/media/craniosacraltherapie-mobile.4e3b1a3b.jpg";